import PropTypes from "prop-types";
import classnames from "classnames";

const ProgressBar = ({ value, total, className = "bg-success" }) => {
    const pct = total > 0 ? Math.min(100, Math.round((value / total) * 100)) : 0;
    return (
        <div className="h-1.5 w-full overflow-hidden rounded-full bg-gray-200">
            <div className={classnames("h-full rounded-full", className)} style={{ width: `${pct}%` }} />
        </div>
    );
};

ProgressBar.propTypes = {
    value    : PropTypes.number,
    total    : PropTypes.number,
    className: PropTypes.string
};

export default ProgressBar;
